import { format } from "date-fns";

/**
 * Parse a date-only string (YYYY-MM-DD) as local midnight.
 *
 * `new Date("2026-04-29")` is parsed as UTC midnight by the JavaScript spec,
 * which causes the date to render one day off for users in timezones ahead of
 * UTC. This function splits the string and constructs a local-time Date instead,
 * which is timezone-safe for display purposes.
 */
export function parseDateOnly(s: string | null | undefined): Date {
  if (!s) return new Date(NaN);
  const datePart = s.includes("T") ? s.split("T")[0] : s.split(" ")[0];
  const [year, month, day] = datePart.split("-").map(Number);
  if (isNaN(year) || isNaN(month) || isNaN(day)) return new Date(NaN);
  return new Date(year, month - 1, day);
}

/**
 * Format a nullable date-only DB string for display.
 *
 * @param s    - A YYYY-MM-DD string, null, or undefined.
 * @param fmt  - A date-fns format string (e.g. "MMM d, yyyy").
 * @param fallback - Value to return when s is falsy. Defaults to "-".
 */
export function formatDateOnly(
  s: string | null | undefined,
  fmt: string,
  fallback = "-"
): string {
  if (!s) return fallback;
  return format(parseDateOnly(s), fmt);
}
